<template>
  <v-main>
    <v-container fluid>
      <v-card elevation="6" rounded="xxl">
        <v-card-title>
          <v-btn
            class="mx-2"
            fab
            x-small
            color="primary"
            @click="$router.back()"
          >
            <v-icon dark> mdi-arrow-left </v-icon> </v-btn
          >Add a User
        </v-card-title>
        <v-card-text>
          <v-row>
            <v-col sm="4">
              <v-text-field
                v-model="form.first_name"
                outlined
                label="First Name *"
                prepend-inner-icon="mdi-buffet"
                :error-messages="errors.first_name"
              ></v-text-field>
            </v-col>
            <v-col sm="4">
              <v-text-field
                v-model="form.middle_name"
                outlined
                label="Middle Name"
                prepend-inner-icon="mdi-buffet"
                :error-messages="errors.middle_name"
              ></v-text-field>
            </v-col>
            <v-col sm="4">
              <v-text-field
                v-model="form.last_name"
                outlined
                label="Last Name *"
                prepend-inner-icon="mdi-buffet"
                :error-messages="errors.last_name"
              ></v-text-field>
            </v-col>
            <v-col sm="4">
              <v-text-field
                v-model="form.email"
                outlined
                label="Email *"
                prepend-inner-icon="mdi-email"
                :error-messages="errors.email"
              ></v-text-field>
            </v-col>
            <v-col sm="4">
              <v-text-field
                v-model="form.password"
                outlined
                label="Password"
                prepend-inner-icon="mdi-lock-off"
                :error-messages="errors.password"
              ></v-text-field>
            </v-col>
            <v-col sm="4">
              <v-text-field
                v-model="form.password_confirmation"
                outlined
                label="Confirm Password"
                prepend-inner-icon="mdi-lock-outline"
                :error-messages="errors.password_confirmation"
              ></v-text-field>
            </v-col>
            <v-col sm="4">
              <v-text-field
                v-model="form.phone"
                outlined
                label="Phone"
                prepend-inner-icon="mdi-phone"
              ></v-text-field>
            </v-col>
            <v-col sm="4">
              <v-autocomplete
                ref="position"
                outlined
                v-model="form.position_id"
                :items="positionItems"
                label="Position *"
                prepend-inner-icon="mdi-account-tie-outline"
                clearable
                :error-messages="errors.position_id"
              ></v-autocomplete>
            </v-col>
           
            <!-- <v-col sm="4">
              <v-switch
                class="mt-0 ml-5"
                v-model="form.is_active"
                inset
                :label="`Is Active: ${form.is_active ? 'YES' : 'NO'}`"
              ></v-switch>
            </v-col> -->
           
          </v-row>
          <v-divider class="mt-5 mb-5"> </v-divider>
          <v-btn
            :loading="isLoading"
            :disabled="isLoading"
            rounded
            color="primary"
            dark
            @click="save"
          >
            Save User
          </v-btn>
        </v-card-text>
      </v-card>
    </v-container>
  </v-main>
</template>
<script>
import axios from "axios";
export default {
  name: "UserCreatePage",
  data() {
    return {
      form: {
        is_active: true,
        soft_password: "123456",
        user_devices: [],
        user_locations: [],
      },
      supervisorDownlined: [
        "Field Executive",
        "Merchandiser",
        "Promoter",
        "Van Sales",
      ],
      companyId: "",
      positionItems: [],
      uplineUserItems: [],
      isDeleteDeviceDialogs: [],
      isDeleteLocationDialogs: [],
      isLoading: false,
      typeItems: [
        { id: "PENDING", text: "PENDING", value: 1 },      
        { id: "APPROVED", text: "APPROVED", value: 0 },
      ],
    };
  },
  mounted() {
    this.form.company_id = this.company.id;
    this.form.role_id = "3";
    console.log(this.companyId);
    this.getMasters();
  },
  methods: {
    async getMasters() {
      await axios
        .get(`masters?context=user`)
        .then((masters) => {
          masters = masters.data;
          //Position
          masters.positions.forEach((position) => {
            this.positionItems.push({
              id: position.id,
              text: position.name,
              value: position.id,
            });
          });
        })
        .catch(function (error) {
          console.log(error);
          // redirect to Home Page
          // window.location.href = "/auth/login";
        });
    },
    async save() {
      try {
        this.isLoading = true;
        await axios.post("/users", this.form);
        this.isLoading = false;
        await this.saveUserTimestamp(null, this.form);
        this.$router.push("/users");
      } catch (e) {
        // alert("error");
        this.isLoading = false;
      }
    },
  },
};
</script>
